import { c as _c } from "react/compiler-runtime";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export function MetadataLink(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.url) {
    t0 = props.url.trim();
    $[0] = props.url;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const url = t0;
  if (!url) {
    return null;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <td>Metadata</td>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>View</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faExternalLink} style={{
      fontSize: "0.8em"
    }} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== url) {
    t4 = <tr>{t1}<td><a href={url} target="_blank" rel="noopener noreferrer" className="d-inline-flex align-items-center gap-1">{t2}{t3}</a></td></tr>;
    $[5] = url;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}